import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-use",
  "use": "icon-use-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-use\"><path d=\"M691.7 326.6l108.5 3.2L319.5 960l116.3-271.1 277.3-350.3H528.4l163.3-227.4h146.5z\" fill=\"#08C6C1\" p-id=\"20255\" /><path d=\"M486.4 360H676L223 912.8l151-389.2H205.5L374 64h326.6z\" fill=\"#08C6C1\" p-id=\"20256\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol